import React from "react";
import "./Loader.css";
const Loader = () => {
  return (
    <div className="loader__container">
      <div className="loader"></div>
    </div>
  );
};

export default Loader;